export default __webpack_public_path__ + "static/media/Gallery1.e312f143.webp";